module.exports = __webpack_public_path__ + "img/top-bac.c4c53181.png";